export default "__VITE_ASSET__6c1814ad__"